import script from "./WaitPayment.vue?vue&type=script&setup=true&lang=ts"
export * from "./WaitPayment.vue?vue&type=script&setup=true&lang=ts"

import "./WaitPayment.vue?vue&type=style&index=0&id=31de050d&scoped=true&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31de050d"]])

export default __exports__